import React from 'react';

import { BENEFITS } from './constants';

import './ContactLensStoreBenefit.scss';

export const ContactLensStoreBenefitExtra = props => {
  const { baseImageUrl } = props;

  const extraBenefits = BENEFITS.filter(({ key }) => ['protect', 'delivery'].includes(key))
    .sort((a, b) => {
      const order = { delivery: 0, protect: 1 };
      return order[a.key] - order[b.key];
    })
    .map(({ key }) => {
      return {
        key,
        icon: BENEFITS.find(({ key: key2 }) => key2 === key).icon,
        text: key === 'delivery' ? 'Free shipping' : 'Secure payment',
      };
    });

  return (
    <div className="contact-lens-store-benefit">
      <div className="contact-lens-store-benefit__container" data-is-extra="true">
        <ul className="contact-lens-store-benefit__list" data-is-extra="true">
          {extraBenefits.map(({ key, icon, text }) => (
            <li
              key={key}
              className="contact-lens-store-benefit__item"
              data-is-extra="true"
              data-key={key}
            >
              <img alt={key} src={`${baseImageUrl}/icons${icon}`} />
              <p className="contact-lens-store-benefit__item__text">{text}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
